import React from "react";
import HeaderMain from "../../components/header/headerMain";
import {
  Back,
  ContainerDad,
  ContainerField,
  ContainerGlobal,
  ContainerTransparent,
  TextInfo,
  Title,
} from "../../styles/PageStyles/LegalAndDocumental/stylesDetailRegister";
import { useLocation, useNavigate } from "react-router-dom";

const DetailRegisterForms = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const register = location.state?.item;

  const goBack = () => {
    navigate(-1); // Regresa a la página anterior
  };

  return (
    <ContainerGlobal>
      <HeaderMain />
      <ContainerTransparent>
        <Back onClick={goBack}>Volver</Back>
        <Title>Detalle de registro</Title>
        <ContainerDad>
          <ContainerField>
            <TextInfo>Nombres:</TextInfo>
            <p>{register.firstName}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Apellidos:</TextInfo>
            <p>{register.lastName}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Correo electrónico:</TextInfo>
            <p>{register.email}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Contacto:</TextInfo>
            <p>{register.phoneNumber}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Contacto 2:</TextInfo>
            <p>{register.secondaryPhoneNumber}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>WhatsApp:</TextInfo>
            <p>{register.optionalPhoneNumber}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Departamento:</TextInfo>
            <p>{register.state.name}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Municipio/Cuidad:</TextInfo>
            <p>{register.cities.name}</p>
          </ContainerField>
          <ContainerField>
            <TextInfo>Barrio/Dirección:</TextInfo>
            <p>{register.neighborhood}</p>
          </ContainerField>
          {register.rumvNumber.length > 0 && (
            <ContainerField>
              <TextInfo>Numero de RUMV:</TextInfo>
              <p>{register.rumvNumber}</p>
            </ContainerField>
          )}
        </ContainerDad>
      </ContainerTransparent>
    </ContainerGlobal>
  );
};

export default DetailRegisterForms;
